import DashboardPage from './components/pages/dashboards/DashboardPage';
import ProfilePage from './components/pages/profile/ProfilePage';
import PaymentPage from './components/pages/office/PaymentPage';
import PayoutPage from './components/pages/office/PayoutPage';
import OperationsHistoryPage from './components/pages/office/OperationsHistoryPage';
import CurrencyRatioPage from './components/pages/office/CurrencyRatioPage';
import GoalsPage from './components/pages/offers/GoalsPage';
import OfferPage from './components/pages/offers/OfferPage';
import StatisticsPage from './components/pages/statistics/StatisticsPage';
import ListPostbackPage from './components/pages/postback/ListPostbackPage';
import CreatePostbackPage from './components/pages/postback/CreatePostbackPage';
import HistoryPostbackPage from './components/pages/postback/HistoryPostbackPage';
import EditPostbackPageComponent from './components/pages/postback/EditPostbackPage/EditPostbackPage.container';
import ConversionPage from './components/pages/conversion/ConversionPage';
import ConversionItemPage from './components/pages/conversion/ConversionItemPage';
import FinanceReportPage from './components/pages/finance/FinanceReportPage';
import PayoutItemPage from './components/pages/office/PayoutItemPage';
import InformationPage from "./components/pages/information/InformationPage";
import config from './config';

const defRoute = config.defaultRoute;
const router = [
    {
        key: 'dashboard',
        params: {
            exact: true,
            component: DashboardPage
        }
    },
    {
        key: 'profile',
        params: {
            path: `${defRoute}office/settings/profile`,
            component: ProfilePage
        }
    },
    {
        key: 'payment',
        params: {
            path: `${defRoute}office/settings/payment`,
            component: PaymentPage
        }
    },
    {
        key: 'information',
        params: {
            path: `${defRoute}office/settings/information`,
            component: InformationPage
        }
    },
    {
        key: 'finance',
        params: {
            path: `${defRoute}office/finances/report`,
            component: FinanceReportPage
        }
    },
    {
        key: 'historyFinance',
        params: {
            path: `${defRoute}office/finances/history`,
            component: OperationsHistoryPage
        }
    },
    {
        key: 'financeCurrency',
        params: {
            path: `${defRoute}office/finances/currency`,
            component: CurrencyRatioPage
        }
    },
    {
        key: 'financeReport',
        params: {
            path: `${defRoute}office/finances/report`,
            component: FinanceReportPage
        }
    },
    {
        key: 'goals',
        params: {
            path: `${defRoute}offers/goals`,
            component: GoalsPage
        }
    },
    {
        key: 'offer',
        params: {
            path: `${defRoute}offers/offer/:id`,
            component: OfferPage
        }
    },
    {
        key: 'statistics',
        params: {
            path: `${defRoute}statistics/report`,
            component: StatisticsPage
        }
    },
    {
        key: 'report',
        params: {
            path: `${defRoute}statistics/report`,
            component: StatisticsPage
        }
    },
    {
        key: 'instruments',
        params: {
            path: `${defRoute}postback/list`,
            component: ListPostbackPage
        }
    },
    {
        key: 'postbacks',
        params: {
            path: `${defRoute}postback/list`,
            component: ListPostbackPage
        }
    },
    {
        key: 'createPostback',
        params: {
            path: `${defRoute}postback/create`,
            component: CreatePostbackPage
        }
    },
    {
        key: 'historyPostback',
        params: {
            path: `${defRoute}postback/history`,
            component: HistoryPostbackPage
        }
    },
    {
        key: 'editPostback',
        params: {
            path: `${defRoute}postback/edit/:id`,
            component: EditPostbackPageComponent
        }
    },
    {
        key: 'conversions',
        params: {
            path: `${defRoute}statistics/conversions`,
            component: ConversionPage
        }
    },
    {
        key: 'conversion',
        params: {
            path: `${defRoute}statistics/conversion/:id`,
            component: ConversionItemPage
        }
    }
];

export default router;
